export const accordianConfigObject = {
  mobile: {
    gridTemplateAreas: '"title . value"',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: 3,
  },
  desktop: {
    gridTemplateAreas: '"title . value"',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: 5,
  },
  tablet: {
    gridTemplateAreas: '"title . value"',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: 4,
  },
}
export const footerConfigObject = {
  mobile: {
    // gridTemplateAreas: '"Link1 sepr1 Link2 sepr1 Link3"',
    gridTemplateAreas: '"Link1 sepr1 Link2"',
    gridTemplateColumns: '1fr 10px 1fr',
    // gridTemplateColumns: '95px 10px 65px 10px 100px',
    gridTemplateRows: '1fr',
    gap: 0,
  },
  desktop: {
    gridTemplateAreas: '"Link1 sepr1 Link2"',
    // gridTemplateAreas: '"Link1 sepr1 Link2 sepr2 Link3"',
    gridTemplateColumns: '1fr 10px 1fr',
    // gridTemplateColumns: '110px 10px 70px 10px 120px',
    gridTemplateRows: '1fr',
    gap: 0,
  },
  tablet: {
    gridTemplateAreas: '"Link1 sepr1 Link2"',
    // gridTemplateAreas: '"Link1 sepr1 Link2 sepr1 Link3"',
    // gridTemplateColumns: '110px 10px 70px 10px 120px',
    gridTemplateColumns: '1fr 10px 1fr',
    gridTemplateRows: '1fr',
    gap: 0,
  },
}
export const appBarConfigObject = {
  mobile: {
    gridTemplateAreas: '"logo title"',
    gridTemplateColumns: '60px 220px',
    gridTemplateRows: '1fr',
    gap: 0,
  },
  desktop: {
    gridTemplateAreas: '"logo title"',
    gridTemplateColumns: '70px 300px',
    gridTemplateRows: '1fr',
    gap: 0,
  },
  tablet: {
    gridTemplateAreas: '"logo title"',
    gridTemplateColumns: '70px 300px',
    gridTemplateRows: '1fr',
    gap: 0,
  },
}

export const layoutConfigObject = {
  mobile: {
    gridTemplateAreas: `"header header header header  "
          " sidebar sidebar sidebar sidebar "
         " main main main main "
         "footer footer footer footer "`,
    gridTemplateColumns: 'repeat(4, 1fr)',
    background: 'red',
    columnGap: 0,
    rowGap: 4,
  },
  desktop: {
    gridTemplateAreas: `" header header header header header header header header header header  header header"
          "main main main main main main main main main main main main"
          "footer footer footer footer footer  footer footer  footer footer  footer footer footer"`,
    gridTemplateColumns: 'repeat(12, 1fr)',
    background: 'yellow',
    columnGap: 3,
    rowGap: 1,
  },
  tablet: {
    gridTemplateAreas: `" header header header header header  header header header  header header"
            " .   sidebar  sidebar sidebar sidebar sidebar sidebar sidebar  sidebar . "
            " . main main main main main main main main ."
            "footer  footer footer  footer footer footer footer  footer footer footer"`,
    gridTemplateColumns: 'repeat(10, 1fr)',
    background: 'green',
    columnGap: 2,
    rowGap: 3,
  },
}
